/** Shared sales-contact helpers (phone / WhatsApp). */

export const FALLBACK_PHONE_DISPLAY = "+91 90050 09500";
export const FALLBACK_PHONE_DIGITS = "919005009500";
export const FALLBACK_EMAIL = "info@servall.in";

export const digitsOnly = (value = "") => String(value).replace(/\D/g, "");

/** Prefer CMS WhatsApp/phone; fall back to live Servall sales number. */
export const resolveWhatsAppDigits = (settings) => {
    const fromSettings = digitsOnly(settings?.social_whatsapp || settings?.support_phone || "");
    if (fromSettings.length >= 10) {
        return fromSettings.startsWith("91") ? fromSettings : `91${fromSettings.slice(-10)}`;
    }
    return FALLBACK_PHONE_DIGITS;
};

export const resolvePhoneDisplay = (settings) =>
    settings?.support_phone || settings?.social_whatsapp || FALLBACK_PHONE_DISPLAY;

export const resolveTelHref = (settings) => {
    const digits = resolveWhatsAppDigits(settings);
    return `tel:+${digits}`;
};

export const whatsappUrl = (digits, text = "") => {
    const base = `https://wa.me/${digitsOnly(digits) || FALLBACK_PHONE_DIGITS}`;
    return text ? `${base}?text=${encodeURIComponent(text)}` : base;
};

export const bikeInquiryMessage = (bike, intent = "whatsapp_inquiry") => {
    const name = bike?.name ? `${bike.brand || ""} ${bike.name}`.trim() : "a bike";
    const price =
        bike?.price_min != null
            ? ` (around ₹${Number(bike.price_min).toLocaleString("en-IN")})`
            : "";
    const intents = {
        test_ride: `Hi Servall Bikes, I'd like to book a test ride for ${name}${price}. Please call me back.`,
        whatsapp_inquiry: `Hi Servall Bikes, I want the best on-road deal for ${name}${price}. Please share today's offer.`,
        loan_inquiry: `Hi Servall Bikes, I need loan / EMI help for ${name}${price}. Please assist.`,
        price_drop: `Hi Servall Bikes, please alert me on price drops for ${name}.`,
        compare_help: `Hi Servall Bikes, I'm comparing bikes and need an expert recommendation.`,
        pre_book: `Hi Servall Bikes, I'm interested in ${name} (coming soon). Please notify me when it's available for test ride and booking.`,
        general: `Hi Servall Bikes, I'd like help choosing a two-wheeler.`,
    };
    return intents[intent] || intents.general;
};

export const emiInquiryMessage = ({ monthly, tenure, price } = {}) => {
    const parts = ["Hi Servall Bikes, I want this EMI approved."];
    if (monthly) parts.push(`Monthly EMI ~₹${Number(monthly).toLocaleString("en-IN")}`);
    if (tenure) parts.push(`for ${tenure} months`);
    if (price) parts.push(`on a bike priced ~₹${Number(price).toLocaleString("en-IN")}`);
    parts.push("Please call me back.");
    return parts.join(" ");
};
